/**
 * Created by yangxy on 2023/12/26.
 * 视频智能AI相关存储
 */
const state = {
  recordInfo: null, //回放信息(SaaS和PaaS共用)
  //   {
  //     "id": 793345,
  //     "webinar_id": 746293418, （vod_id时没有)
  //     "name": "互动直播测试1212",
  //     "user_id": 101643,
  //     "created_at": "2023-12-26 11:57:36",
  //     "duration": 7058,
  //     "storage": 117391,
  //     "audit_status": 0,
  //     "transcode_status": 1,
  //     "paas_record_id": "fbbf62c1",
  //     "encrypt_status": 0,
  //     "vod_id": "fbbf62c1", （vod_id时返回有，等于paas_record_id)
  //  }
  playBackInfo: null,
  //   {
  //     "paasAppId": "f14ed109",
  //     "accountId": 101643,
  //     "paasAccessToken": "access:f14ed109:c4404519ef2e5468",
  //     "recordName": "互动直播测试1212",
  //     "doc": {
  //         "isVod": "1",
  //         "channelId": "ch_K1WrVGdX",
  //         "roomId": "lss_24d4fe6d"
  //     },
  //     "player": {
  //         "type": "vod",
  //         "poster": "https://cnstatic01.e.vhall.com/upload/common/static-imgs/c0/e7/c0e7569408de296971eb4b98945c240b.png",
  //         "paasRecordId": "fbbf62c1"
  //     },
  //     "report_data": {
  //         "vid": 101643,
  //         "vfid": 101643,
  //         "biz_id": 746293418,
  //         "guid": "u_101643",
  //         "report_extra": "{\"vid\":\"101643\",\"vfid\":\"101643\",\"biz_id\":746293418,\"biz_role\":6,\"join_id\":2239781,\"switch_id\":3664493,\"is_filter\":1,\"aid\":\"inav_3ae04da7\"}"
  //     }
  // }
  asrStatus: -1, // 语音识别结果查询状态, -1 未知，0:不存在，1:成功，2:失败，3:进行中 4: 重新（继续）校正 10: 校正完成
  asrLang: 'zh', // 语音识别结果语言： zh：中文， en：英文
  asrData: null, // 语音识别结果数据

  isPlaying: false, // 视频是否在播放中
  totalTime: null, //视频总时长

  markpoints: [], //视频打点

  hasVodDoc: false, // 是否有回放文档

  clipStatus: -1 // 精彩剪辑查询状态，-1 待查询, 0:不存在，1:成功，2:失败，3:进行中
};

// mutations
const mutations = {
  setRecordInfo: (state, obj) => {
    state.recordInfo = obj;
  },
  setPlayBackInfo: (state, obj) => {
    state.playBackInfo = obj;
  },
  setAsrStatus: (state, val) => {
    state.asrStatus = val;
  },
  setAsrLang: (state, val) => {
    state.asrLang = val;
  },
  setAsrData: (state, obj) => {
    state.asrData = obj;
  },
  updateAsrContent: (state, arr) => {
    if (state.asrData) {
      state.asrData.content = arr;
    }
  },
  setIsPlaying: (state, val) => {
    state.isPlaying = val;
  },
  setTotalTime: (state, val) => {
    state.totalTime = val;
  },

  /**
   * 视频增加打点
   * @param {Array|Object} points 打点信息
   * @param {Boolean} isReset 是否重新设置, 默认false
   */
  addMarkpoints: (state, { points, isReset = false }) => {
    if (!points) return;
    if (Array.isArray(points)) {
      state.markpoints = isReset ? points : state.markpoints.concat(points);
    } else if (Object.prototype.toString.call(points) === '[object Object]') {
      if (isReset) {
        state.markpoints = [points];
      } else {
        state.markpoints.push(points);
      }
    }
  },
  setHasVodDoc: (state, val) => {
    state.hasVodDoc = val;
  },

  setClipStatus: (state, val) => {
    state.clipStatus = val;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
